// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import Vue from "vue";

// For each matching file name...
export default function installGlobalComponentsVite() {
    // Vite's version of webpack's require.context: every .vue file below this folder
    const componentsContext = import.meta.glob("./**/*.vue", { eager: true });

    Object.keys(componentsContext).forEach((fileName) => {
        const componentConfig = componentsContext[fileName];
        const componentName = fileName
            .split("/")
            .pop()
            .replace(/\.\w+$/, "");
        Vue.component(
            componentName,
            componentConfig.default || componentConfig,
        );
    });
}
